module.exports = __webpack_public_path__ + "img/app_sub_true.f1e8d5e3.svg";